<template>
    <section >
        <h3 class="section-title">
            О продукте
        </h3>
        <div class="text-container text-container__about valign">
            <h3 class="text-title">Продолжаем сезон барбекю!<br>И проводим его с максимальной пользой для кишечника.</h3>
            <div class="text-main">
                <!--<p><span>БАКТИСТАТИН ®</span> — комплекс 3-х природных компонентов, усиливающих действие друг друга: <span>метабиотик</span>, <span>пребиотик</span>-->
                    <!--и <span>природный сорбент (цеолит)</span>.<br>-->
                    <!--Взаимодополняющее действие 3-х компонентов способствует:-->
                    <!--<ul>-->
                        <!--<li> устранению дисбактериоза</li>-->
                        <!--<li>восстановлению микрофлоры кишечника</li>-->
                        <!--<li>выведению шлаков и токсинов из организма</li>-->
                        <!--<li>улучшению процессов пищеварения</li>-->
                        <!--<li>укреплению иммунной системы</li>-->
                    <!--</ul>-->
                <!--</p>-->

                <p><span>БАКТИСТАТИН ®</span> — комплекс дополняющих друг друга 3-х природных компонентов**:
                <ul>
                    <li>Метаболиты Bacillus subtilis (способствуют полноценному пищеварению)</li>
                    <li>Природный сорбент цеолит (уменьшает различные виды интоксикации, нормализует перистальтику кишечника)</li>
                    <li>Пребиотический компонент (обеспечивает благоприятные условия для роста и восстановления нормальной микрофлоры кишечника)</li>
                </ul>
                </p>


            </div>
            <div class="text-bottom clearfix">
                <div class="text-main">
                    <p><span>Открываете сезон барбекю — не&nbsp;забудьте про БАКТИСТАТИН®!</span></p>
                    <a href="http://www.bactistatin.com/about/" target="_blank" class="btn btn-hover" @click = "gaMore"><span>узнать больше</span></a><Arrow></Arrow>
                </div>
                <div class="image-right">
                    <img src="/static/images/baktistatin.png" alt="Baktistatin">
                    <img class="shadow" src="/static/images/shadow.png" alt="Baktistatin">
                </div>

            </div>
        </div>
        <div class="decoration-container decoration-container__about">
            <div class="layer layer__1" :style="{transform: 'rotate('+angle+'deg)'}">
                <transition name="fade-left-top" appear>
                    <img src="/static/images/item-7-2.png" alt="Item">
                </transition>
                <transition name="fade-left-top" appear>
                     <img src="/static/images/item-6-2.png" alt="Item">
                </transition>
                <transition name="fade-left-top" appear>
                  <img src="/static/images/item-5-2.png" alt="Item">
                </transition>
                <transition name="fade-left-bottom" appear>
                     <img src="/static/images/item-2-2.png" alt="Item">
                </transition>
                <transition name="fade-left-bottom" appear>
                    <img src="/static/images/item-3-2.png" alt="Item">
                </transition>
                <transition name="fade-right-top" appear>
                    <img src="/static/images/item-1.png" alt="Item">
                </transition>
                <transition name="fade-right-top" appear>
                    <img src="/static/images/item-4.png" alt="Item">
                </transition>
                <transition name="fade-right-bottom" appear>
                    <img src="/static/images/grill2.png" alt="Item">
                </transition>

            </div>
            <div class="layer layer__2" :style="{transform: 'rotate(-'+angle+'deg)'}">
                <transition name="fade-left-top" appear>
                    <Item1></Item1>
                </transition>
                <transition name="fade-left-bottom" appear>
                    <Item2></Item2>
                </transition>
                <transition name="fade-right-top" appear>
                    <Item3></Item3>
                </transition>
                <transition name="fade-right-bottom" appear>
                    <Item4></Item4>
                </transition>
            </div>
        </div>
    </section>
</template>

<script>
    import {TweenMax} from 'gsap';
    import Arrow from '../../assets/svg/arrow-long.svg';
    import Item1 from '../../assets/svg/item-1.svg';
    import Item2 from '../../assets/svg/item-2.svg';
    import Item3 from '../../assets/svg/item-3.svg';
    import Item4 from '../../assets/svg/item-4.svg';

    export default {
        name: 'About',
        data () {
            return {
                angle: 0
            }
        },


        mounted(){
            let self = this;
            document.body.addEventListener('mousemove',function(e){
                self.angle = (e.clientX+e.clientY)/1000;
            })
        },
        components: {
            Arrow,
            Item1,
            Item2,
            Item3,
            Item4
        },
        methods: {
            gaMore(){
                ga('send', 'event', 'redirect', 'show', 'About Page Redirect');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// About.vue?f690fb22